/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react';

import { useFormik } from 'formik';

import {
  coordinatesUpdate,
  getUserCoordinates,
  setLocation,
  userActions,
  userCoordinates,
  userLocation,
} from '@pharmaplan/common';

import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';
import { ICommonProfile } from '../../PharmacistFlow/General/General';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { CoordinatesValidator } from '../../FormValidation';
import ProfileForm from '../../ProfileForm';

const Coordinates = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const coordinates = useAppSelector(userCoordinates);
  const location = useAppSelector(userLocation);

  const formik = useFormik({
    initialValues: {
      ...coordinates,
    },
    onSubmit: (values) => {
      const filterdValues = { ...values };
      // @ts-ignore
      delete filterdValues.provinces;
      dispatch(
        coordinatesUpdate({
          ...filterdValues,
          latitude: location.latitude,
          longitude: location.longitude,
          address: values?.address,
        }),
      );
    },
    enableReinitialize: true,
    validationSchema: CoordinatesValidator(),
  });

  const { disabled } = useDisableProfileSave({
    action: userActions.coordinatesUpdate,
    mutableValues: formik.values,
    initialValue: coordinates,
    replacer: (obj) =>
      ({
        ...obj,
        latitude: obj?.latitude?.toFixed?.(5),
        longitude: obj?.longitude?.toFixed?.(5),
      }),
  });

  useEffect(() => {
    dispatch(getUserCoordinates());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      setLocation({
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinates.latitude, coordinates.longitude]);

  return (
    <ProfileForm
      setSelected={setSelected}
      selected="coordinates"
      formik={formik}
      disableSave={disabled}
    />
  );
};

export default Coordinates;
